export default __webpack_public_path__ + "images/favicon-bunnings.06043dd3a8dc65f7185ab87c325959cb.png";